import { useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { Locate, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

// Icono para la ubicación del usuario
const userLocationIcon = new L.DivIcon({
  className: 'user-location-marker',
  html: `<div style="
    width: 20px;
    height: 20px;
    background: #3b82f6;
    border: 3px solid white;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.5);
  "></div>`,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

export function GeolocationButton({ onLocationFound }) {
  const map = useMap();
  const [loading, setLoading] = useState(false);
  const [userMarker, setUserMarker] = useState(null);

  async function handleGeolocate() {
    if (!navigator.geolocation) {
      toast.error('Tu navegador no soporta geolocalización');
      return;
    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        
        // Centrar mapa en la ubicación
        map.flyTo([latitude, longitude], 13, { duration: 1 });

        // Eliminar marcador anterior si existe
        if (userMarker) {
          map.removeLayer(userMarker);
        }

        // Añadir marcador de ubicación del usuario
        const marker = L.marker([latitude, longitude], { icon: userLocationIcon })
          .addTo(map)
          .bindPopup('Tu ubicación actual');
        
        setUserMarker(marker);
        setLoading(false);

        // Callback opcional
        if (onLocationFound) {
          onLocationFound({ latitude, longitude });
        }

        toast.success('Ubicación encontrada');
      },
      (error) => {
        setLoading(false);
        switch (error.code) {
          case error.PERMISSION_DENIED:
            toast.error('Permiso de ubicación denegado');
            break;
          case error.POSITION_UNAVAILABLE:
            toast.error('Ubicación no disponible');
            break;
          case error.TIMEOUT:
            toast.error('Tiempo de espera agotado');
            break;
          default:
            toast.error('Error al obtener ubicación');
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000
      }
    );
  }

  return (
    <Button
      variant="secondary"
      size="icon"
      className="absolute top-3 right-3 z-[1000] bg-white shadow-md hover:bg-gray-100"
      onClick={handleGeolocate}
      disabled={loading}
      aria-label="Mi ubicación"
      data-testid="geolocate-btn"
    >
      {loading ? (
        <Loader2 className="h-5 w-5 animate-spin" />
      ) : (
        <Locate className="h-5 w-5" />
      )}
    </Button>
  );
}

export default GeolocationButton;
